var $1c6e1539193f1243$exports = {};
$1c6e1539193f1243$exports = {
    "Empty": `Leer`
};


export {$1c6e1539193f1243$exports as default};
//# sourceMappingURL=de-DE.module.js.map
